import { Grid, Button } from "@mui/material"
import { useCallback, useEffect, useState } from "react"
import LoaderWrapper from "../../components/wrapper/LoaderWrapper"
import { useNavigate, useParams } from "react-router-dom";
import useLinkService from "../../services/linkService";
import { useAsync, useAsyncFn } from "../../hooks/useAsync";
import { useSnackbarAlert } from "../../context/snackbarAlert";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/auth";
import SetPasswordForm from "../../components/form/SetPasswordForm/SetPasswordForm";
import PageFooter from "../../components/pageFooter";
import InformationDialog from "../../components/dialog/InformationDialog";

export default function LinkPage(props) {
    const navigate = useNavigate();

    const { onSuccessLogin } = useAuth()
    const { kind, token } = useParams();
    const [isTokenValid, setTokenValid] = useState(undefined);
    const [showReceptionConfirmedDialog, setShowReceptionConfirmedDialog] = useState(false);

    const { t } = useTranslation();

    const snackbarAlert = useSnackbarAlert();

    const { checkLink, activateLink } = useLinkService();

    const activateLinkFn = useAsyncFn(activateLink);

    const checkLinkValidity = useAsync(
        () => checkLink(kind, token).then((res) => {
            setTokenValid(res)
            if (kind === "reception" && res) {
                activateLinkFn.execute(kind, token)
                    .then(() => {
                        setShowReceptionConfirmedDialog(true);
                    })
                    .catch(() => {
                        snackbarAlert.openErrorSnackbarAlert(
                            t("snackbar_alert.occurred_error_during_saving_changes")
                        );
                    });

            } else {
                snackbarAlert.openErrorSnackbarAlert(
                    t("snackbar_alert.bad_link")
                );

                window.location.href = "https://oliviahome.com/"
            }
        }

        ),
        []
    );

    useEffect(() => {
        if (checkLinkValidity.loading) {
            return;
        }
        setTokenValid(checkLinkValidity.value);
        if (checkLinkValidity.value === false) {
            if (kind === "reception") {
                window.location.href = "https://oliviahome.com/"
            } else {
                navigate('/')
            }
            snackbarAlert.openErrorSnackbarAlert(
                t("snackbar_alert.bad_link")
            );
        }
    }, [checkLinkValidity.loading]);


    const onActivateLink = useCallback((newPassword) => {
        activateLinkFn.execute(kind, token, { password: newPassword })
            .then(() => {
                navigate('/')
                snackbarAlert.openSuccessSnackbarAlert(
                    t("snackbar_alert.account_activated")
                );
            })
            .catch(() => {
                snackbarAlert.openErrorSnackbarAlert(
                    t("snackbar_alert.occurred_error_during_saving_changes")
                );
            });
    }, [kind, token])



    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
        >

            <Grid item sm={2} xs={0} />
            <Grid item sm={8} xs={12}>
                <LoaderWrapper showLoader={isTokenValid === undefined}>
                    <Grid
                        container
                        direction="column"
                        justifyContent="flex-start"
                        alignItems="center"
                        style={{ minHeight: "75vh" }}
                    >
                        {isTokenValid && kind !== "reception" ?
                            <SetPasswordForm
                                onSubmit={onActivateLink}
                                isAccountActivate={true}
                            />
                            :
                            <Grid item xs={12} marginTop={10}>
                                <Grid container direction="row" justifyContent="flex-end">
                                    <Button size="small" variant="outlined" onClick={() => navigate('/')}>
                                        {t("form.set_password_form.back")}
                                    </Button>
                                </Grid>
                            </Grid>}

                    </Grid>
                </LoaderWrapper >
            </Grid>
            <Grid item sm={2} xs={0} />
            <Grid item xs={12}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="center"
                    className="margin-top-medium"
                ></Grid>
            </Grid>

            <Grid item xs={12}>
                <PageFooter />
            </Grid>

            <InformationDialog
                open={showReceptionConfirmedDialog}
                content={t("page.link_page.reception_date_confirmed")}
                onClose={() => {
                    window.location.href = "https://oliviahome.com/"
                }}
            />
        </Grid>
    );

}